import styled from 'styled-components';

const LoginPageContainer = styled.div`
  position: fixed;
  top: calc((100vh - 600px) / 2);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export default {
  LoginPageContainer
};
